<template>
  <v-container class="max-width-1200">

    <v-row class="justify-center">
      <v-col cols="12" md="7">
        <v-row>
          <v-col class="pb-0 headline text-uppercase">
            {{ $t('itSolutions.softwareDevelopment.title') }}
          </v-col>
        </v-row>
        <v-row>
          <v-col  class="display-1">
            {{ $t('itSolutions.softwareDevelopment.subtitle')}}
          </v-col>
        </v-row>
        <v-row>
          <v-col class="text-justify">
            {{ $t('itSolutions.softwareDevelopment.text.01')}}<br>
            {{ $t('itSolutions.softwareDevelopment.text.02')}}
          </v-col>
        </v-row>
        <!-- <v-row>
          <v-col>
            {{ $t('company.vision.text.01')}}
          </v-col>
        </v-row> -->
      </v-col>
      <v-col cols="12" md="5" class="align-center d-flex">
        <v-img
          src="@/assets/img/it-softwaredevelopment-01.jpeg"
          contain
          class="ml-auto"
          style="width:100%">
        </v-img>
      </v-col>
    </v-row>

    <v-row>
      <v-col>

      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import DataComponentBase from '@/commons/DataComponentBase';

  export default {
    name: 'SoftwareDevelopment',
    extends: DataComponentBase,

    data: () => ({

    }),

    methods: {

    },
  }
</script>
